module.exports = __webpack_public_path__ + "static/media/M1-17-Furtóvi-cod126.b14fc4d1.png";